import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../RgInteraction.module.scss';

const Generic = ({
  closeRgPopup,
  goToRgTools,
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Your Game, Your Rules
      </div>
      <div>We want to make sure your time with us is always enjoyable.
        We offer a variety of ways to help you stay in total control of how you play:
      </div>
      <ul className={styles.list}>
        <li><b>Deposit Limits:</b> Set a budget that works for you.</li>
        <li><b>Time Outs:</b> Take a quick break whenever you need it.</li>
        <li><b>Self-Exclusion:</b> Longer-term options for total peace of mind.</li>
      </ul>
      <div>
        <span>
          It’s always worth a quick check to see if your current settings still suit your style.
        </span>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={closeRgPopup}
      >
        Not Now
      </Button>
      <Button
        sizeType="wider"
        buttonType="primary"
        onClick={goToRgTools}
        className={styles.primaryButton}
      >
        Review My Settings
      </Button>
    </div>
  </Fragment>
);

Generic.propTypes = {
  closeRgPopup: PropTypes.func.isRequired,
  goToRgTools: PropTypes.func.isRequired,
};

export default Generic;

